const orderToastMsg = {
  CAN_NOT_CANCEL_PART_ORDER_ITEM:
    '안전 거래(에스크로)가 적용되어 부분 환불이 불가합니다. 개발팀으로 변경 요청 바랍니다.',

  /**
   *  [주문 전체 리스트] 주문 전체 리스트 요청하기
   */
  GET_ORDER_ALL_LIST_REQUEST_SUCCESS: '주문 전체 리스트 요청하기 성공',
  GET_ORDER_ALL_LIST_REQUEST_ERROR: '주문 전체 리스트 요청하기 실패',

  /**
   *  [주문 전체 리스트] 주문 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '주문 전체 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '주문 전체 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [주문 취소 리스트] 주문 취소 리스트 요청하기
   */
  GET_ORDER_CANCEL_LIST_REQUEST_SUCCESS: '주문 취소 리스트 요청하기 성공',
  GET_ORDER_CANCEL_LIST_REQUEST_ERROR: '주문 취소 리스트 요청하기 실패',

  /**
   *  [주문 취소 리스트] 주문 취소 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '주문 취소 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_CANCEL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '주문 취소 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [주문 반품 리스트] 주문 반품 리스트 요청하기
   */
  GET_ORDER_RETURN_LIST_REQUEST_SUCCESS: '주문 반품 리스트 요청하기 성공',
  GET_ORDER_RETURN_LIST_REQUEST_ERROR: '주문 반품 리스트 요청하기 실패',

  /**
   *  [주문 반품 리스트] 주문 반품 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '주문 반품 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_RETURN_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '주문 반품 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [주문 교환 리스트] 주문 교환 리스트 요청하기
   */
  GET_ORDER_EXCHANGE_LIST_REQUEST_SUCCESS: '주문 교환 리스트 요청하기 성공',
  GET_ORDER_EXCHANGE_LIST_REQUEST_ERROR: '주문 교환 리스트 요청하기 실패',

  /**
   *  [주문 교환 리스트] 주문 교환 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '주문 교환 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_EXCHANGE_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '주문 교환 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [주문/배송관리] 주문/배송관리 리스트 요청하기
   */
  GET_ORDER_MANAGEMENT_LIST_REQUEST_SUCCESS: '주문/배송관리 리스트 요청하기 성공',
  GET_ORDER_MANAGEMENT_LIST_REQUEST_ERROR: '주문/배송관리 리스트 요청하기 실패',

  /**
   *  [주문/배송관리] 상품 주문 상품 준비 처리하기
   */
  DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST_SUCCESS: '상품 주문 상품 준비 요청하기 성공',
  DELIVERY_PREPARATION_ORDER_MANAGEMENT_REQUEST_ERROR: '상품 주문 상품 준비 요청하기 실패',

  /**
   *  [주문/배송관리] 상품 주문 배송 지연처리하기
   */
  DELIVERY_DELAY_ORDER_MANAGEMENT_REQUEST_SUCCESS: '상품 주문 배송 지연 요청하기 성공',
  DELIVERY_DELAY_ORDER_MANAGEMENT_REQUEST_ERROR: '상품 주문 배송 지연 요청하기 실패',

  /**
   *  [주문/배송관리] 상품 주문 발송 처리전 유효성 체크하기
   */
  CHECK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_ERROR: '상품 주문 일괄 발송 처리전 유효성 체크하기 실패',

  /**
   *  [주문/배송관리] 상품 주문 엑셀 일괄 발송 처리전 유효성 체크하기
   */
  CHECK_EXCEL_BULK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_SUCCESS:
    '상품 주문 엑셀 일괄 발송 처리전 유효성 체크하기 성공',
  CHECK_EXCEL_BULK_DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_ERROR:
    '상품 주문 엑셀 일괄 발송 처리전 유효성 체크하기 실패',

  /**
   *  [주문/배송관리] 상품 주문 발송 처리하기
   */
  DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_SUCCESS: '상품 주문 발송 처리하기 성공',
  DELIVERY_DISPATCH_ORDER_MANAGEMENT_REQUEST_ERROR: '상품 주문 발송 처리하기 실패',

  /**
   *  [주문/배송관리] 판매 취소 전 재고, 상품상태 설정 리스트 가져오기
   */
  GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_REQUEST_SUCCESS: '재고/상품상태 설정 정보 리스트 가져오기 성공',
  GET_CANCEL_ORDER_MANAGEMENT_INFO_LIST_REQUEST_ERROR: '재고/상품상태 설정 정보 리스트 가져오기 실패',

  /**
   *  [주문/배송관리] 판매 취소하기
   */
  CANCEL_SALES_ORDER_MANAGEMENT_REQUEST_SUCCESS: '판매 취소하기 성공',
  CANCEL_SALES_ORDER_MANAGEMENT_REQUEST_ERROR: '판매 취소하기 실패',

  /**
   *  [주문/배송관리] 주문자 정보 수정하기
   */
  EDIT_BUYER_INFO_REQUEST_SUCCESS: '주문자 정보 수정하기 성공',
  EDIT_BUYER_INFO_REQUEST_ERROR: '주문자 정보 수정하기 실패',

  /**
   *  [주문/배송관리] 송장 수정하기
   */
  EDIT_DELIVERY_INFO_REQUEST_SUCCESS: '송장 수정하기 성공',
  EDIT_DELIVERY_INFO_REQUEST_ERROR: '송장 수정하기 실패',

  /**
   *  [주문/배송관리] 전체 엑셀 다운로드
   */
  GET_ALL_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '주문/배송관리 전체 리스트 엑셀 다운로드 실패',

  /**
   *  [주문/배송관리] 선택 엑셀 다운로드
   */
  GET_SELECTED_ORDER_MANAGEMENT_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '주문/배송관리 선택 리스트 엑셀 다운로드 실패',

  /**
   *  [취소 관리] 취소 관리 리스트 요청하기
   */
  GET_ORDER_CANCEL_MANAGEMENT_LIST_REQUEST_SUCCESS: '취소관리 리스트 요청하기 성공',
  GET_ORDER_CANCEL_MANAGEMENT_LIST_REQUEST_ERROR: '취소관리 리스트 요청하기 실패',

  /**
   *  [취소 관리] 취소 관리 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_CANCEL_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS:
    '취소관리 전체 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_CANCEL_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '취소관리 전체 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [취소 관리] 취소 관리 선택 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_CANCEL_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS:
    '취소관리 선택 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_CANCEL_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR:
    '취소관리 선택 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [취소 관리] 취소 거부 요청하기
   */
  REJECT_ORDER_CANCEL_ITEM_DATA_REQUEST_SUCCESS: '취소 거부 요청하기 성공',
  REJECT_ORDER_CANCEL_ITEM_DATA_REQUEST_ERROR: '취소 거부 요청하기 실패',

  /**
   *  [취소 관리] 취소 완료 요청 전 상품 또는 옵션의 재고, 상태 설정 리스트 요청하기
   */
  GET_ORDER_CANCEL_ITEM_STOCK_AND_STATUS_DATA_LIST_REQUEST_SUCCESS: '재고/상품상태 설정 정보 리스트 가져오기 성공',
  GET_ORDER_CANCEL_ITEM_STOCK_AND_STATUS_DATA_LIST_REQUEST_ERROR: '재고/상품상태 설정 정보 리스트 가져오기 실패',

  /**
   *  [취소 관리] 취소 완료 요청하기
   */
  COMPLETE_ORDER_CANCEL_ITEM_DATA_REQUEST_SUCCESS: '취소 완료 요청하기 성공',
  COMPLETE_ORDER_CANCEL_ITEM_DATA_REQUEST_ERROR: '취소 완료 요청하기 실패',

  /**
   *  [취소 관리] 택배사 리스트 가져오기
   */
  GET_DELIVERY_AGENT_LIST_REQUEST_ERROR: '택배사 리스트 가져오기 실패',

  /**
   *  [취소 관리] 취소 거부 -> 발송 처리하기
   */
  DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_REQUEST_SUCCESS: '발송 처리 요청하기 성공',
  DELIVERY_DISPATCH_ORDER_CANCEL_ITEM_DATA_REQUEST_ERROR: '발송 처리 요청하기 실패',

  /**
   *  [반품 관리] 반품 관리 리스트 요청하기
   */
  GET_ORDER_RETURN_MANAGEMENT_LIST_REQUEST_SUCCESS: '반품관리 리스트 요청하기 성공',
  GET_ORDER_RETURN_MANAGEMENT_LIST_REQUEST_ERROR: '반품관리 리스트 요청하기 실패',

  /**
   *  [반품 관리] 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_RETURN_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS:
    '반품관리 전체 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_RETURN_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '반품관리 전체 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [반품 관리] 선택 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_RETURN_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS:
    '반품관리 선택 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_RETURN_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR:
    '반품관리 선택 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [반품 관리] 반품 수거 완료 요청하기
   */
  COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS: '반품 수거 완료 요청하기 성공',
  COMPLETE_COLLECTION_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR: '반품 수거 완료 요청하기 실패',

  /**
   *  [반품 관리] 반품 거부 요청하기
   */
  REJECT_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS: '반품 거부 요청하기 성공',
  REJECT_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR: '반품 거부 요청하기 실패',

  /**
   *  [반품 관리] 반품 사유 수정하기 전 필요한 데이터 요청하기
   */
  GET_PREPARATION_MODIFY_REASON_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS:
    '반품 사유 수정하기 전 필요한 데이터 요청하기 성공',
  GET_PREPARATION_MODIFY_REASON_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR:
    '반품 사유 수정하기 전 필요한 데이터 요청하기 실패',

  /**
   *  [반품 관리] 반품 사유 수정 요청하기
   */
  EDIT_ORDER_RETURN_ITEM_REASON_DATA_REQUEST_SUCCESS: '반품 사유 수정 요청하기 성공',
  EDIT_ORDER_RETURN_ITEM_REASON_DATA_REQUEST_ERROR: '반품 사유 수정 요청하기 실패',

  /**
   *  [반품 관리] 반품 승인 요청하기
   */
  COMPLETE_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS: '반품 승인 요청하기 성공',
  COMPLETE_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR: '반품 승인 요청하기 실패',

  /**
   *  [반품 관리] 반품 -> 교환 요청하기
   */
  CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_REQUEST_SUCCESS: '반품에서 교환으로 변경 요청하기 성공',
  CHANGE_EXCHANGE_ORDER_RETURN_ITEM_DATA_REQUEST_ERROR: '반품에서 교환으로 변경 요청하기 실패',

  /**
   *  [반품 관리] 반품 사유, 반품 거부 사유 상세 데이터 요청하기
   */
  GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_REQUEST_SUCCESS: '반품 사유, 반품 거부 사유 이미지 요청하기 성공',
  GET_ORDER_RETURN_ITEM_ATTACHMENT_DATA_REQUEST_ERROR: '반품 사유, 반품 거부 사유 이미지 요청하기 실패',

  /**
   *  [교환 관리] 교환 관리 리스트 요청하기
   */
  GET_ORDER_EXCHANGE_MANAGEMENT_LIST_REQUEST_SUCCESS: '교환관리 리스트 요청하기 성공',
  GET_ORDER_EXCHANGE_MANAGEMENT_LIST_REQUEST_ERROR: '교환관리 리스트 요청하기 실패',

  /**
   *  [교환 관리] 전체 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_EXCHANGE_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS:
    '교환관리 전체 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_EXCHANGE_MANAGEMENT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR:
    '교환관리 전체 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [교환 관리] 선택 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_EXCHANGE_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS:
    '교환관리 선택 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_EXCHANGE_MANAGEMENT_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR:
    '교환관리 선택 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [교환 관리] 교환 수거 완료 요청하기
   */
  COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS: '교환 수거 완료 요청하기 성공',
  COMPLETE_COLLECTION_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR: '교환 수거 완료 요청하기 실패',

  /**
   *  [교환 관리] 교환 거부 요청하기
   */
  REJECT_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS: '교환 거부 요청하기 성공',
  REJECT_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR: '교환 거부 요청하기 실패',

  /**
   *  [교환 관리] 교환 사유 수정하기 전 필요한 데이터 요청하기
   */
  GET_PREPARATION_EDIT_REASON_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS:
    '교환 사유 수정하기 전 필요한 데이터 요청하기 성공',
  GET_PREPARATION_EDIT_REASON_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR:
    '교환 사유 수정하기 전 필요한 데이터 요청하기 실패',

  /**
   *  [교환 관리] 교환 사유 수정 요청하기
   */
  EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_REQUEST_SUCCESS: '교환 사유 수정 요청하기 성공',
  EDIT_ORDER_EXCHANGE_ITEM_REASON_DATA_REQUEST_ERROR: '교환 사유 수정 요청하기 실패',

  /**
   *  [교환 관리] 택배사 리스트 가져오기
   */
  GET_DELIVERY_AGENT_LIST_FOR_ORDER_EXCHANGE_REQUEST_ERROR: '택배사 리스트 가져오기 실패',

  /**
   *  [교환 관리] 교환 재배송 송장 수정 요청하기
   */
  EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_REQUEST_SUCCESS: '교환 재배송 송장 수정 요청하기 성공',
  EDIT_ORDER_EXCHANGE_ITEM_DELIVERY_INFO_REQUEST_ERROR: '교환 재배송 송장 수정 요청하기 실패',

  /**
   *  [교환 관리] 교환 승인 요청하기
   */
  COMPLETE_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS: '교환 승인 요청하기 성공',
  COMPLETE_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR: '교환 승인 요청하기 실패',

  /**
   *  [교환 관리] 교환 -> 반품 요청하기
   */
  CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_REQUEST_SUCCESS: '교환에서 반품으로 변경 요청하기 성공',
  CHANGE_RETURN_ORDER_EXCHANGE_ITEM_DATA_REQUEST_ERROR: '교환에서 반품으로 변경 요청하기 실패',

  /**
   *  [교환 관리] 교환 사유, 교환 거부 사유 이미지 요청하기
   */
  GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_REQUEST_SUCCESS: '교환 사유, 교환 거부 사유 이미지 요청하기 성공',
  GET_ORDER_EXCHANGE_ITEM_ATTACHMENT_DATA_REQUEST_ERROR: '교환 사유, 교환 거부 사유 이미지 요청하기 실패',

  /**
   *  [주문 상세] 주문 상세 요청하기
   */
  GET_ORDER_DETAIL_REQUEST_SUCCESS: '주문 상세 요청하기 성공',
  GET_ORDER_DETAIL_REQUEST_ERROR: '주문 상세 요청하기 실패',

  /**
   * [주문 상세] 주문 상태 되돌리기 요청하기
   */
  CHANGE_ORDER_ITEM_STATUS_REQUEST_SUCCESS: '주문 상태 되돌리기 요청하기 성공',
  CHANGE_ORDER_ITEM_STATUS_REQUEST_ERROR: '주문 상태 되돌리기 요청하기 실패',

  /**
   *  [주문 반품 상세] 주문 반품 상세 요청하기
   */
  GET_ORDER_RETURN_DETAIL_REQUEST_SUCCESS: '주문 반품 상세 요청하기 성공',
  GET_ORDER_RETURN_DETAIL_REQUEST_ERROR: '주문 반품 상세 요청하기 실패',

  /**
   *  [주문 반품 상세] 주문 반품 환불 완료하기
   */
  SET_COMPLETE_REFUND_ORDER_RETURN_REQUEST_SUCCESS: '주문 반품 환불 완료하기 성공',
  SET_COMPLETE_REFUND_ORDER_RETURN_REQUEST_ERROR: '주문 반품 환불 완료하기 실패',

  /**
   *  [주문상세] 교환 요청하기
   */
  SUBMIT_ORDER_EXCHANGE_REQUEST_SUCCESS: '교환 요청하기 성공',
  SUBMIT_ORDER_EXCHANGE_REQUEST_ERROR: '교환 요청하기 성공',

  /**
   *  [주문상세] 반품 요청하기
   */
  SUBMIT_ORDER_RETURN_REQUEST_SUCCESS: '반품 요청하기 성공',
  SUBMIT_ORDER_RETURN_REQUEST_ERROR: '반품 요청하기 성공',

  /**
   *  [주문상세] cs 메모 등록 요청하기
   */
  INSERT_ORDER_ITEM_CS_MEMO_REQUEST_SUCCESS: 'CS 메모 등록 요청하기 성공',
  INSERT_ORDER_ITEM_CS_MEMO_REQUEST_ERROR: 'CS 메모 등록 요청하기 실패',

  /**
   *  [주문상세] cs 메모 업데이트 요청하기
   */
  EDIT_ORDER_ITEM_CS_MEMO_REQUEST_SUCCESS: 'CS 메모 업데이트 요청하기 성공',
  EDIT_ORDER_ITEM_CS_MEMO_REQUEST_ERROR: 'CS 메모 업데이트 요청하기 실패',

  /**
   *  [주문상세] 1:1 문의 리스트 요청하기
   */
  GET_ORDER_ITEM_CS_INQUIRY_LIST_REQUEST_SUCCESS: '1:1 문의 리스트 요청하기 성공',
  GET_ORDER_ITEM_CS_INQUIRY_LIST_REQUEST_ERROR: '1:1 문의 리스트 요청하기 실패',

  /**
   *  [주문상세] 1:1 문의 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_ITEM_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '1:1 문의 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_ITEM_CS_INQUIRY_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '1:1 문의 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [주문상세] 상품 문의 리스트 요청하기
   */
  GET_ORDER_ITEM_CS_QNA_LIST_REQUEST_SUCCESS: '상품 문의 리스트 요청하기 성공',
  GET_ORDER_ITEM_CS_QNA_LIST_REQUEST_ERROR: '상품 문의 리스트 요청하기 실패',

  /**
   *  [주문상세] 상품 문의 리스트 엑셀 다운로드 요청하기
   */
  GET_ORDER_ITEM_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 문의 리스트 엑셀 다운로드 요청하기 성공',
  GET_ORDER_ITEM_CS_QNA_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 문의 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [주문상세] 반품요청에 필요한 데이터 요청하기
   */
  GET_PREPARATION_ORDER_RETURN_REQUEST_SUCCESS: '반품요청에 필요한 데이터 요청하기 성공',
  GET_PREPARATION_ORDER_RETURN_REQUEST_ERROR: '반품요청에 필요한 데이터 요청하기 실패',
};

export default orderToastMsg;
